import React, { Component } from 'react';
import { Spin, message } from 'antd';
import { getNamesByLanguage } from '../../constants';
import FooterButton from '../Components/FooterButton';
import PartModule from './Components/PartModule';
import Comment from './Table/Comment';

let names = {};

class Detail extends Component {
    state = {
        stage: '',
        loading: false,
        editable: false,
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable });
        names = getNamesByLanguage('detail', language);
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            const { status } = this.props;
            status === 'add' && this.props.changeStep(1);
        }
    }

    toggleEditable = (editable) => {
        this.setState({ editable });
    }

    render() {
        const { status, height, language, mode = '' } = this.props;
        const { loading, editable, stage } = this.state;
        const showIaIb = stage === 'Ia+Ib期';
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    {
                        showIaIb ?
                            <div>
                                <PartModule title={`${names.title}(Ia期)`} mode={mode} editable={editable} names={names} language={language} ref={el => this.IaRef = el} />
                                <PartModule title={`${names.title}(Ib期)`} mode={mode} editable={editable} names={names} language={language} ref={el => this.IbRef = el} />
                            </div>
                        :
                            <PartModule title={names.title} mode={mode} editable={editable} names={names} language={language} ref={el => this.IaRef = el} />
                    }
                    <Comment title={names.comments} mode={mode} editable={editable} names={names} language={language} />
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

export default Detail;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/index.js